// extracted by mini-css-extract-plugin
module.exports = {"container":"Group_container__1F1eX","item":"Group_item__3TVX7"};